<script lang="ts">
  type Props = {
    value: { current: number };
    min: number;
    max: number;
    step?: number;
    id?: string;
  };

  let { value, min, max, step = 1, id }: Props = $props();

  const THUMB = 18;
  const TRACK = 4;
  const pct = $derived((value.current - min) / (max - min));
</script>

<input
  type="range"
  {id}
  value={value.current}
  oninput={(e) => { value.current = e.currentTarget.valueAsNumber; }}
  {min}
  {max}
  {step}
  style="--pct: {pct}; --thumb: {THUMB}px; --track: {TRACK}px"
/>

<style lang="scss">
  @use '~/theme/themify' as *;
  @use 'sass:color';

  input[type='range'] {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: none;

    @include themify {
      --slider-accent: #{themed('link')};
      --slider-track: #{color.mix(themed('background'), themed('link'), 75%)};
    }
  }

  input[type='range']::-webkit-slider-runnable-track {
    height: var(--track);
    border-radius: 999px;
    background: linear-gradient(
      to right,
      var(--slider-accent) calc(var(--pct) * (100% - var(--thumb)) + var(--thumb) / 2),
      var(--slider-track) calc(var(--pct) * (100% - var(--thumb)) + var(--thumb) / 2)
    );
  }

  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: var(--thumb);
    height: var(--thumb);
    border-radius: 50%;
    border: none;
    background-color: var(--slider-accent);
    cursor: pointer;
    margin-top: calc((var(--track) - var(--thumb)) / 2);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  input[type='range']::-moz-range-track {
    height: var(--track);
    border-radius: 999px;
    background: var(--slider-track);
  }

  input[type='range']::-moz-range-progress {
    height: var(--track);
    border-radius: 999px;
    background: var(--slider-accent);
  }

  input[type='range']::-moz-range-thumb {
    width: var(--thumb);
    height: var(--thumb);
    border-radius: 50%;
    border: none;
    background-color: var(--slider-accent);
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }
</style>
